export default function Container(props) {
  const { tag, id, onClick, onMouseLeave, style, className } = props;

  const Tag = tag || "section";

  return (
    <Tag
      id={id}
      style={style}
      className={className ? className : ""}
      onClick={onClick ? onClick : undefined}
      onMouseLeave={onMouseLeave ?? undefined}
    >
      {props.children}
    </Tag>
  );
}
